import { DIMENSIONS, DIMENSION_LABELS } from "../../dashboard/analytics";

function pairKey(a, b) {
  return [a, b].sort().join(" + ");
}

export function HeatmapPairs({ pairCounts }) {
  const keys = DIMENSIONS;
  const values = keys.flatMap((a, i) =>
    keys.map((b, j) => (i < j ? pairCounts[pairKey(a, b)] || 0 : 0))
  );
  const max = Math.max(1, ...values);

  return (
    <div className="heatmap-scroll">
      <table className="heatmap">
        <thead>
          <tr>
            <th />
            {keys.map((k) => (
              <th key={k} title={DIMENSION_LABELS[k]}>
                {DIMENSION_LABELS[k].replace(" Architecture", "").replace(" Structure", "").replace(" Signal", "").slice(0, 8)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {keys.map((row, ri) => (
            <tr key={row}>
              <th title={DIMENSION_LABELS[row]}>{DIMENSION_LABELS[row].slice(0, 12)}</th>
              {keys.map((col, ci) => {
                if (ci <= ri) {
                  return <td key={col} className="heatmap__empty" />;
                }
                const v = pairCounts[pairKey(row, col)] || 0;
                const intensity = v / max;
                return (
                  <td
                    key={col}
                    className="heatmap__cell"
                    style={{ "--i": intensity }}
                    title={`${pairKey(DIMENSION_LABELS[row], DIMENSION_LABELS[col])}: ${v}`}
                  >
                    {v || "—"}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
